module.exports = __webpack_public_path__ + "static/media/book_armaghan_ae_hijaz_urdu_4.e7daa6ad.jpg";